"use client"

interface DroppodSystemsTextProps {
  scale: number
}

export const DroppodSystemsText = ({ scale }: DroppodSystemsTextProps) => {
  // Position: original was left: 140, top: 112
  // Move 20px north: top = 112 - 20 = 92
  return (
    <div
      id="droppod-systems-text"
      className="absolute"
      style={{
        left: 140 * scale,
        top: 92 * scale,
      }}
    >
      <span
        className="text-cyan-400 font-bold uppercase tracking-wider"
        style={{
          fontSize: 6 * scale,
          textShadow: "0 0 4px rgba(100, 200, 255, 0.5), 0 0 8px rgba(0, 0, 0, 0.8), 0 0 16px rgba(0, 0, 0, 0.6), 0 0 24px rgba(0, 0, 0, 0.4)",
        }}
      >
        all systems go
      </span>
    </div>
  )
}
